import DefaultLayout from "../layouts/DefaultLayout";
import useTranslation from "../hooks/translations";
import InputField from "../components/InputField";
import {useMemo, useRef, useState} from "react";
import {Form, Nav} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import {useApi} from "../contexts/ApiProvider";
import UserService from "../services/UserService";
import {toast} from "react-toastify";

export default function AccountSecurityPage() {
  const translations = useTranslation();
  const api = useApi();
  const userService = useMemo(() => new UserService(api), [api]);

  const oldPasswordField = useRef();
  const newPasswordField = useRef();
  const confirmPasswordField = useRef();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (event) => {
    event.preventDefault();

    const errors = {};

    const oldPassword = oldPasswordField.current.value;
    const newPassword = newPasswordField.current.value;
    const confirmPassword = confirmPasswordField.current.value;

    if (!oldPassword) {
      errors.oldPassword = translations.errorOldPassword;
    }
    if (!newPassword) {
      errors.newPassword = translations.errorNewPassword;
    }
    if (!confirmPassword) {
      errors.confirmPassword = translations.errorConfirmPassword;
    }
    if (newPassword !== confirmPassword) {
      errors.confirmPassword = translations.errorConfirmMismatchPassword;
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const result = await userService.changePassword({
      old_password: oldPassword,
      new_password: newPassword
    })

    if (result.ok) {
      oldPasswordField.current.value = "";
      newPasswordField.current.value = "";
      confirmPasswordField.current.value = "";
      toast.success(translations.passwordUpdateSuccess)
    }
  }

  return (
    <DefaultLayout header="CostCategory">
      <div className="container-xl px-4 mt-4">
        <nav className="nav nav-borders">
          <Nav.Link as={NavLink} to="/account-profile"
                    className="nav-link">
            {translations.account}</Nav.Link>
          <Nav.Link as={NavLink} to="/account-security"
                    className="nav-link">
            {translations.security}</Nav.Link>
        </nav>
        <hr className="mt-0 mb-4"/>
        <div className="row">
          <div className="col-lg-8">
            <div className="card mb-4">
              <div className="card-header">{translations.changePassword}</div>
              <div className="card-body">
                <Form onSubmit={onSubmit}>
                  <div className="mb-3">
                    <InputField
                      type="password"
                      name="oldPassword"
                      label={translations.oldPassword}
                      placeholder={translations.enterOldPassword}
                      error={formErrors.oldPassword}
                      fieldRef={oldPasswordField}
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      type="password"
                      name="newPassword"
                      label={translations.newPassword}
                      placeholder={translations.enterNewPassword}
                      error={formErrors.newPassword}
                      fieldRef={newPasswordField}
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      type="password"
                      name="confirmPassword"
                      label={translations.confirmPassword}
                      placeholder={translations.enterConfirmPassword}
                      error={formErrors.confirmPassword}
                      fieldRef={confirmPasswordField}
                    />
                  </div>
                  <button className="btn btn-primary"
                          type="submit">{translations.save}
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}
